import { Link, useLocation } from 'react-router-dom';

export default function Footer() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const scrollToSection = (id: string) => {
    if (isHomePage) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = `/#${id}`;
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <h4 className="text-xl font-bold mb-4">株式会社ArrayVenture</h4>
            <p className="text-teal-50 text-sm leading-relaxed">
              最先端の技術と柔軟な対応力で、お客様のIT課題を解決します。
            </p>
          </div>
          <div>
            <h5 className="font-semibold mb-4">クイックリンク</h5>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/company" className="text-teal-50 hover:text-white transition-colors cursor-pointer">
                  会社概要
                </Link>
              </li>
              <li>
                {isHomePage ? (
                  <button onClick={() => scrollToSection('services')} className="text-teal-50 hover:text-white transition-colors cursor-pointer">
                    事業内容
                  </button>
                ) : (
                  <Link to="/#services" className="text-teal-50 hover:text-white transition-colors cursor-pointer">
                    事業内容
                  </Link>
                )}
              </li>
              <li>
                {location.pathname === '/contact' ? (
                  <button onClick={() => {
                    const element = document.getElementById('flow');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }} className="text-teal-50 hover:text-white transition-colors cursor-pointer">
                    開発の流れ
                  </button>
                ) : (
                  <Link to="/contact#flow" className="text-teal-50 hover:text-white transition-colors cursor-pointer">
                    開発の流れ
                  </Link>
                )}
              </li>
              <li>
                {location.pathname === '/contact' ? (
                  <button onClick={() => {
                    const element = document.getElementById('contact');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }} className="text-teal-50 hover:text-white transition-colors cursor-pointer">
                    お問い合わせ
                  </button>
                ) : (
                  <Link to="/contact#contact" className="text-teal-50 hover:text-white transition-colors cursor-pointer">
                    お問い合わせ
                  </Link>
                )}
              </li>
            </ul>
          </div>
          <div>
            <h5 className="font-semibold mb-4">お問い合わせ</h5>
            <div className="space-y-2 text-sm text-teal-50">
              <p>〒103-0012</p>
              <p>東京都中央区日本橋堀留町1-3-16 JSB日本橋913</p>
              <p>
                <a href="mailto:hayato.imaizumi@array-venture.com" className="hover:text-white transition-colors cursor-pointer">
                  hayato.imaizumi@array-venture.com
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className="border-t border-teal-500 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-teal-50">
          <p>© 株式会社ArrayVenture All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
}
